import { useEffect, useState } from "react";
import { dataDecrypt, dataEncrypt } from "../app/utils/encryption-helper";
import { useNavigate, useParams } from "react-router-dom";
import { ApisService } from "../app/core/apis.service";
import { ProductView } from "../components/product-view";
import { AppConfig } from "../app/config";
import { IoArrowBackSharp } from "react-icons/io5";
import { formatDateTimeInIST } from "../components/indiaDateFormate";

export const PurchaseOrderView = () => {
    const routerParams = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [transactionData, setTransactionData] = useState<any>([]);
    useEffect(() => {
        loadTransaction();
    }, []);

    async function loadTransaction(): Promise<void> {
        setLoading(true);
        const decryptData: any = JSON.parse(dataDecrypt(routerParams.id as string));
        let payload = {
            filters: {
                id: decryptData.id
            }
        }
        try {
            const encryptedPayload = dataEncrypt(JSON.stringify(payload));
            const quotationData = await ApisService.getTransactionData("getQuotations", encryptedPayload || "");
            const decryptQuotationData = JSON.parse(dataDecrypt(quotationData.data.data));
            setTransactionData(decryptQuotationData[0]);
            setLoading(false);
        }
        catch (error) {
            setLoading(false);
        }
    }

    const getUnitPrice = (unit_price: number, quantity: number, total_amount: any) => {
        if ((quantity > 1) && (unit_price === total_amount)) {
            const unitQuantity = (unit_price / quantity);
            return unitQuantity;
        }
        else {
            return unit_price;
        }
    }

    const getTotalPrice = (products: any[]) => {
        return products?.reduce((sum, item) => sum + item.product_cost, 0);
    };

    const getPrintQuotation = () => {
        window.open(`${AppConfig.BASE_URL}/pdfs/${transactionData?._id}/quotation-pdf`, "_blank");
    }

    return (
        <div className="p-2">
            {loading ? <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <div className="spinner-border text-secondary" role="status"></div>
            </div> : <div className="container-fluid">
                <div className="d-flex justify-content-between mb-2 align-items">
                    <div className="cursor-pointer fs-14" onClick={() => navigate(-1)}><IoArrowBackSharp size={20} /></div>
                    <div className="primary-color">
                        <h5 className="mb-0 py-1 text-center fw-bold">QUOTATION</h5>
                    </div>
                    <div className="text-end">
                        <ins className="cursor-pointer primary-color fw-bold fs-16" onClick={() => getPrintQuotation()}>View</ins>
                    {/* <button className="primary-background fs-14 px-4 rounded" onClick={() => getPrintQuotation()}>Print</button> */}
                    </div>
                </div>
                {/* <div className="row mb-2 align-items-center">
                    <div className="col-12 primary-color">
                        <h5 className="mb-0 py-1 text-center">QUOTATION</h5>
                    </div>
                    <div className="col-6 text-end">
                    <button className="primary-background fs-14 px-4 rounded" onClick={() => getPrintQuotation()}>Print</button>
                    </div>
                </div> */}
                <div className="d-flex justify-content-end fs-14 mb-3">
                    <div className="row">
                        <div className="col-8 col-md-8 text-end pe-0">Quotation #</div>
                        <div className="col-4 col-md-4 pe-0 fw-bold">{transactionData?.quotation_number}</div>
                        <div className="col-8 col-md-8 text-end pe-0">Quotation Date</div>
                        <div className="col-4 col-md-4 pe-0 fw-bold">{formatDateTimeInIST(transactionData?.created_dt, 'date')}</div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <h6 className="mb-1 fw-bold">Quotation From</h6>
                        <div className="fs-14">
                            <div>{transactionData?.seller?.name},</div>
                            {transactionData?.seller?.address && <div>
                                {transactionData?.seller?.address?.plot_no && <span>{transactionData?.seller?.address?.plot_no},</span>}{transactionData?.seller?.address?.buildinghousenumber && <span>{transactionData?.seller?.address?.buildinghousenumber},</span>}{transactionData?.seller?.address?.buildingstreetname && <span>{transactionData?.seller?.address?.buildingstreetname},</span>}{transactionData?.seller?.address?.villagetowncity && <span>{transactionData?.seller?.address?.villagetowncity},</span>}{transactionData?.seller?.address?.state && <span>{transactionData?.seller?.address?.state},</span>}{transactionData?.seller?.address?.country && <span>{transactionData?.seller?.address?.country},</span>}{transactionData?.seller?.address?.postcode && <span>{transactionData?.seller?.address?.postcode}.</span>}
                                <div>{transactionData?.seller?.contact_number}.</div>
                            </div>}
                        </div>
                    </div>
                    <div className="col-6">
                        <h6 className="mb-1 fw-bold">Quotation To</h6>
                        <div className="fs-14">
                            <div>{transactionData?.buyer?.name},</div>
                            {transactionData?.buyer?.address && <div>
                                {transactionData?.buyer?.address?.plot_no && <span>{transactionData?.buyer?.address?.plot_no},</span>}{transactionData?.buyer?.address?.buildinghousenumber && <span>{transactionData?.buyer?.address?.buildinghousenumber},</span>}{transactionData?.buyer?.address?.buildingstreetname && <span>{transactionData?.buyer?.address?.buildingstreetname},</span>}{transactionData?.buyer?.address?.villagetowncity && <span>{transactionData?.buyer?.address?.villagetowncity},</span>}{transactionData?.buyer?.address?.state && <span>{transactionData?.buyer?.address?.state},</span>}{transactionData?.buyer?.address?.country && <span>{transactionData?.buyer?.address?.country},</span>}{transactionData?.buyer?.address?.postcode && <span>{transactionData?.buyer?.address?.postcode}.</span>}
                            </div>}
                        </div>
                    </div>
                </div>
                <div className="table-responsive my-2">
                    <table className="table table-bordered" >
                        <thead>
                            <tr className="text-center fs-14">
                                <th className="primary-background">S.No</th>
                                <th className="primary-background">Product Name</th>
                                <th className="primary-background">HSN Code</th>
                                <th className="primary-background">Quantity</th>
                                <th className="primary-background">Batch Number</th>
                                <th className="primary-background">Unit Price</th>
                                <th className="primary-background">Product Cost</th>
                                <th className="primary-background">Offer Value</th>
                                <th className="primary-background">Offer Amount</th>
                                <th className="primary-background">Product Total With Offer</th>
                                <th className="primary-background">SGST(%)</th>
                                <th className="primary-background">SGST</th>
                                <th className="primary-background">CGST(%)</th>
                                <th className="primary-background">CGST</th>
                                <th className="primary-background">GST Total</th>
                                <th className="primary-background">Product Amount Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {transactionData?.quotation_details?.products?.map((product: any, index: number) => (
                                <tr key={index} className="fs-14 text-center">
                                    <th>{index + 1}</th>
                                    <td>{product.product_name}</td>
                                    <td>{product?.hsn_code}</td>
                                    <td>{product.quantity}</td>
                                    <td>{product?.batch_number}</td>
                                    <td>{product.unit_price?.toFixed(2)}</td>
                                    <td>{product?.product_cost?.toFixed(2)}</td>
                                    <td>{product?.offer || 0}</td>
                                    <td>{product?.offer_amount?.toFixed(2)}</td>
                                    <td>{product?.product_total_offer?.toFixed(2)}</td>
                                    <td>{product?.sgst_unit}</td>
                                    <td>{product?.sgst}</td> 
                                    <td>{product?.cgst_unit}</td>
                                    <td>{product?.cgst}</td>
                                    <td>{product?.gst_total}</td>
                                    <td>{product.product_cost?.toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="row fs-14">
                    <div className="col-md-8 col-12 mt-2"></div>
                    <div className="col-md-4 col-12 mt-2">
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <td>Product Cost</td>
                                    <td>₹ {transactionData?.quotation_details?.products_cost?.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>Total Offer</td>
                                    <td>₹ {transactionData?.quotation_details?.total_offer?.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>Sub Total</td>
                                    <td>₹ {transactionData?.quotation_details?.sub_total?.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>SGST Total</td>
                                    <td>₹ {transactionData?.quotation_details?.sgst_total?.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>CGST Total</td>
                                    <td>₹ {transactionData?.quotation_details?.cgst_total?.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>Total Price</td>
                                    <td>₹ {transactionData?.quotation_details?.total_price?.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>Additional Discount</td>
                                    <td>₹ {transactionData?.quotation_details?.additional_discount_value?.toFixed(2) || 0}</td>
                                </tr>
                                <tr>
                                    <td>Total Amount</td>
                                    <td>₹ {transactionData?.quotation_details?.final_amount?.toFixed(2)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* <div className="row ">
                    <div className="col-md-8 mt-2 mb-1">
                        {<ProductView data={transactionData?.quotation_details && transactionData?.quotation_details?.products} stylesData="col-md-12 mb-2" />}
                    </div>
                    <div className="col-md-4 mt-2">
                        <div className="card box-shadow rounded-4 border-0 p-3 mb-3">
                            <div className="card-body p-0">
                                <h4 className="fw-bold">Quotation Summary</h4>

                                {transactionData?.quotation_details?.products?.map(
                                    (productEl: any, index: number) => (
                                        <div
                                            className="d-flex justify-content-between align-items-center py-2 border-bottom fs-14"
                                            key={index}
                                        >
                                            <div className="text-truncate" style={{ maxWidth: "70%" }}>
                                                {productEl?.quantity} Qty  <b>x</b> {getUnitPrice(productEl.unit_price , productEl?.quantity, productEl.product_cost )}
                                            </div>
                                            <div className="fw-semibold">₹ {productEl.product_cost}</div>
                                        </div>
                                    )
                                )}

                                <div className="mt-2 border-bottom fs-16">
                                    <div className="d-flex justify-content-between fw-bold pb-2">
                                        <span>Total</span>
                                        <span>₹ {getTotalPrice(transactionData?.quotation_details?.products)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>}
        </div>
    )
}